<template>
	<div>
		<!-- <buttonlist  @exps="exps"  @search="search" @reflash="reflash" ref="SetBtn"></buttonlist> -->
		<!-- <el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-button type="primary" size="mini"  @click="send">获取数据</el-button>
				</div>
			</div>
		</el-card> -->
<!-- <div style="display: flex;background: white">
		<el-card class="box-card" style="width: 20%;">
		<div slot="header" class="clearfix">
		<span>卡片名称</span>
		</div>
		<div v-for="o in 4" :key="o" class="text item">
		{{'列表内容 ' + o }}
		</div>
		</el-card>
		<el-card class="box-card" style="width: 20%;">
		<div slot="header" class="clearfix">
		<span>卡片名称</span>
		</div>
		<div v-for="o in 4" :key="o" class="text item">
		{{'列表内容 ' + o }}
		</div>
		</el-card>
</div>		 -->
	
 <el-divider content-position="left">{{$t('getapi[7267]')}}</el-divider>
		<table>
		<tr>
		<td style="width:60px;text-align: right"  >{{$t('getapi[7268]')}}</td>
		<td style="width:150px;">
		<el-select filterable v-model="dataDetail.cboyear"  size="mini" style="margin-righ:20px">
		<el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
		</el-select>
		</td>

		<td>
			<span style="color:blue">{{$t('getapi[7269]')}}</span>

		</td>
		

		</tr>
		<tr>
		<td style="width:60px;text-align: right">{{$t('getapi[7270]')}}</td>
		<td style="width:150px;">
		<el-select filterable v-model="dataDetail.cbomonth"  size="mini" style="margin-righ:20px" >
		<el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
		</el-select>
		</td>
		<td>
			<span style="color:blue">{{$t('getapi[7271]')}}</span>

		</td>

		</tr>
		

		</table>


 

 <el-divider content-position="left">{{$t('getapi[7272]')}}</el-divider>
 <table>
		
		<tr>
		<td style="width:150px;text-align: right"  >{{$t('getapi[7272]')}}</td>
		<td style="width:150px;">
		{{txt1}}
		</td>
		<td style="width:60px"></td>
		<td style="width:150px;text-align: right"  >{{$t('getapi[7274]')}}</td>
		<td style="width:150px;">
		{{txt4}}
		</td>
		</tr>
		<tr>
		<td style="width:150px;text-align: right"  >{{$t('getapi[7275]')}}</td>
		<td style="width:150px;">
		{{txt5}}
		</td>
		<td style="width:60px"></td>
		<td style="width:150px;text-align: right"  ></td>
		<td style="width:150px;">
		</td>
		</tr>
		
		</table>

		<el-button type="primary" :loading="loading" @click="confirmDoCaculate()">{{$t('getapi[7276]')}}</el-button>

	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_conhourmanager',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight-240,
                maxHeight: this.$windowSize.tableHeight-240,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight-180
        }
    },
	data() {
		return {
			txt1:'/',
			txt4:'/',
			txt5:'未开始',
			fileList: [],
			uploadurl:'',
			startMonth:'',
			endMonth:'',
			IsNew:true,
			IsBOM:false,
			IsCheck1:false,
			IsCheck2:false,
			IsCheck3:false,
			IsCheck4:false,
			IsCaculate:'未计算',
			IsSure:'未标定',
			dataDetail:{
                    cboyear: '',
                    cbomonth: '',
                },
			yearList:[],
			monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
			viewurl:'/CostCalc/ActualCsotView/GetSumRunningHourView',
			expurl:'/CostCalc/ActualCsotView/GetSumRunningHourViewToExecl',
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 100, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectIDList: [],
			getPlanStatus:null,
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			btn: {
				btn1: false,
				btn2:false,
				btn3:false,
				btn4:false,
				btn5:false,
				btn6:false,
				btnbegin:false,
				btnstop:false,
			}
		};
	},
	beforeDestroy(){
	//console.log('关闭')
	if(!this.$limits.fnIsEmpty(this.getPlanStatus)){
	clearInterval(this.getPlanStatus)
	this.getPlanStatus = null
	}
	},
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		let token = JSON.parse(that.userData).token;
		that.uploadurl = Common.Url + '/CostCalc/ActualCsotView/ImportStdChargeRate?token=' + token;
		let thisyear = new Date().getFullYear();
		for(let i=0;i<10;i++){
		let obj = {
		value: thisyear-i,
		label:thisyear-i
		};
		that.yearList.push(obj);
		}
		that.dataDetail.cboyear = thisyear;
		that.authority();
		

	},
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('SalLogicticscsvViewInfo',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
		downFile(){
		let that = this;
		let param = {
		TYear: that.dataDetail.cboyear,
		Month: that.dataDetail.cbomonth,
		}
		that.$http.urlpost('/CostCalc/ActualCsotView/GetStdChargeRateImportTmp', param, function (res) {
		if (res.Success == 1) {
		let hrefurl = Common.Url + res.DataContent.URL;
		window.open(hrefurl);
		}
		});
		},
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
			let limits=1;
			//that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);

			//that.$refs.SetBtn.SetButtonEnable('export',true);
			//that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			return;

			// //只读权
			// if (that.$limits.ReadOnlyRightsView('plv2', 375, 1, that.total)) {
			// 	if (that.total > 0) {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 	} else {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 	}
			// }
			// //操作权限-查询级别
			// limits = that.$limits.OperationAuthorityView('plv2', 375, 1, that.total);
			// // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			// switch (limits) {
			// 	case -1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	default:
			// 		break;
			// }
			// if(limits==-1||limits==1)that.closeAllRightButton();
            // else that.btnauthority();
		},
		btnauthority() {
			let that = this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
			
		},
		handleRemove(file, fileList) {
		console.log(file, fileList);
		},
		handlePreview(file) {
		console.log("handlePreview"+file);
		},
		handleChange(file, fileList) {
		let that = this;
		that.loading = true;
		console.log(file);
		if (file.response) {
		let response = file.response.Success;
		if (response == 0) {
		that.$message.error(file.response.Msg);
		}
		that.loading = false;
		}
		},
		handleSuccess(res, file, fileList) {
		let that = this;
		console.log(res);
		let response = res.Success;
		if (response == 0) {
            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg))
		} else {
            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
		}
		that.fileList=[];
		that.loading = false;
		},
		handleError(err, file, fileList) {
		let that = this;
		that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
		that.loading = false;
		},

		PostCaculate(param){
			let that = this;
			that.txt5 = '计算中...';
			that.$http.urlpost('/CostCalc/ActualCsotView/GetSumRunningHourMatch', param, function (res) {
			console.log('begin conhourmanager...')
			})
		},
		confirmDoCaculate(){
			//计算会更新
			let that = this;
			if(that.$limits.fnIsEmpty(that.dataDetail.cbomonth)||that.$limits.fnIsEmpty(that.dataDetail.cboyear)){
				that.$message.warning(that.$t('getapi[8783]'));//'年月不能为空'
				return;
			}

			that.$confirm(that.$t('getapi[8603]'), that.$t('getapi[194]'), {
			confirmButtonText: that.$t('getapi[1146]'),
			cancelButtonText: that.$t('getapi[2054]'),
			type: 'warning'
			})
			.then(() => {
			that.doCaculate();
			})
			.catch(() => {
			this.$message({
			type: 'info',
			message: that.$t('getapi[6096]')
			});
			});


		},
		doCaculate(){
			let that = this;

			let data={
				TYear: that.dataDetail.cboyear,
				Month: that.dataDetail.cbomonth,
				LangType: that.$processdata.getLang(),
			}
			that.loading = true;
			//当前计算年月
			//that.txt1 = that.dataDetail.cboyear+'年-'+that.dataDetail.cbomonth+'月';
			//开始计算时间
			that.txt1=that.$limits.getDateTime();
			//开启定时器
			//开始询问计算是否完成
			that.getPlanStatus = setInterval(() => {
			that.$http.urlpost('/CostCalc/ActualCsotView/GetSumRunningHourMatchClose', '', function (res) {
			if (res.Success == 1) {
				if(!that.$limits.fnIsEmpty(res.Key)){
				that.$message.success(that.$t('getapi[6431]'));//"计算完成"
				//Msg.服务器结束时间
				that.txt4 =that.$limits.getDateTime();
				that.txt5 = '本次计算完成';
				//关闭定时器
				if(!that.$limits.fnIsEmpty(that.getPlanStatus)){
				clearInterval(that.getPlanStatus);
				that.getPlanStatus = null;
				that.loading = false;
				}
			}
			
			}

			//success=0 就一直询问

			});
			}, 5000);

			that.PostCaculate(data);
			
		},
		
		changeperiod() {
			let that = this;
			that.$http.urlpost('/Inv/Manager/InvInfoUpdateShelflife', that.selectObj, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
					that.getView();
				}
				that.dialogVisible = false;
			});
		},
		showdialog() {
			let that = this;
			if (that.selectObj.exclusively_id == 0) {
				that.$message.warning(that.$t('getapi[8623]'));//'请选择一项！'
				return;
			}
			that.dialogVisible = true;
		},
		handleSelectionChange(val) {
		let that = this;
		that.selectIDList=val;
		if(that.selectIDList.length>0){
			that.btn.send = true;
			that.btn.delete = true;
			that.btn.print = true;
		}else{
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		}
		},
		
		handleSizeChange(val) {
			this.pageSize = val;
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'SumRunningHourInfo');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost(that.viewurl, data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = Common.methods.getDatetime()
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		
		
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
